module.exports = __webpack_public_path__ + "media/hero_img.56ba5e04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero_img.jpg
// module id = 569
// module chunks = 0